


































































































































import Vue from "vue";
import { Component } from "vue-property-decorator";
import {
  BoxIcon,
  DownloadIcon,
  EyeIcon,
  GlobeIcon,
  LayoutIcon,
  LoaderIcon,
  PieChartIcon,
  PowerIcon,
  SlidersIcon,
  StarIcon,
  // @ts-ignore
} from "vue-feather-icons";
import { mapGetters, mapState } from "vuex";
import User from "@/models/user";
import Project from "@/models/project/project";

@Component({
  components: {
    BoxIcon,
    DownloadIcon,
    EyeIcon,
    GlobeIcon,
    LayoutIcon,
    LoaderIcon,
    PieChartIcon,
    PowerIcon,
    SlidersIcon,
    StarIcon,
  },
  computed: {
    ...mapState("authentication", ["user"]),
    ...mapState("projects", ["activeProjectId", "projects"]),
    ...mapState("projects", ["queueBusy"]),
    ...mapGetters("subscriptions", [
      "hasActiveSubscription",
      "hasPausedSubscription",
    ]),
  },
})
export default class NavBar extends Vue {
  // mapState + mapGetters
  user!: User;
  activeProjectId!: string;

  projects!: Array<Project>;
  queueBusy!: boolean;
  hasActiveSubscription!: boolean;
  hasPausedSubscription!: boolean;

  get localActiveProjectId(): string {
    return this.activeProjectId;
  }

  set localActiveProjectId(id: string) {
    this.$store.commit("projects/setActiveProjectById", id);
  }

  isActiveMenuItem(name: string): boolean {
    if (this.$route.matched.some((m) => m.name == name)) {
      return true;
    }

    return false;
  }

  logout() {
    this.$store.dispatch("authentication/logout").then(() => {
      this.$router.push({ name: "login" });
    });
  }
}
